import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
import { judgeObj, judgeArr, uniqueArr } from '@/shared/functions';
const initState = {
    items: [],
    totalNum: 0,
    pageIndex: 1,
    pageSize: 20,
    tableLoading: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 加载列表
         */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { pageIndex, pageSize } = state;
                const _param = {
                    pageIndex,
                    pageSize,
                };
                this.SET_STATE({ tableLoading: true });
                let result = { totalNum: 0, items: [] };
                Api.report.reportList(_param).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (judgeObj(data) && judgeArr(data.items)) {
                        const dealItems = uniqueArr(data.items);
                        result = {
                            totalNum: data.totalNumber,
                            items: dealItems,
                        };
                    }
                }).finally(() => {
                    this.SET_STATE({
                        tableLoading: false,
                        items: result.items,
                        totalNum: result.totalNum,
                    });
                });
            });
        },
        /**
         * @desc 删除操作
         */
        onDelete(payload, { update, state, rootState }) {
            const { id } = payload;
            Api.report.deleteReportForm(id).then((res) => {
                if (res) {
                    notification.success({
                        message: '操作成功',
                    });
                    this.RESET_STATE();
                    this.load({});
                }
                else {
                    notification.error({
                        message: '操作失败',
                    });
                }
            });
        },
        /**
         * @desc 重新生成操作
         */
        onReCreate(payload, { update, state, rootState }) {
            Api.report.createReport({ id: payload }).then((res) => {
                if (res) {
                    notification.success({
                        message: '操作成功',
                    });
                    this.RESET_STATE();
                    this.load({});
                }
                else {
                    notification.error({
                        message: '操作失败',
                    });
                }
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
    },
});
